import { render } from "./MiNTNewsTop.vue?vue&type=template&id=a50c1dbc&scoped=true"
const script = {}

import "./MiNTNewsTop.vue?vue&type=style&index=0&id=a50c1dbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50c1dbc"]])

export default __exports__